import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgExclamation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={8.37} cy={8.596} r={6.5} stroke="#17181A" />
    <path
      d="m8.932 4.592-.192 5.76h-.744l-.192-5.76h1.128Zm-1.224 7.464c0-.184.064-.34.192-.468a.663.663 0 0 1 .468-.192c.184 0 .34.064.468.192a.637.637 0 0 1 .192.468.644.644 0 0 1-.204.468.623.623 0 0 1-.456.192.663.663 0 0 1-.468-.192.663.663 0 0 1-.192-.468Z"
      fill="#17181A"
    />
  </svg>
);
const Memo = memo(SvgExclamation);
export default Memo;
